import React from 'react'

const AprIcon = ({ color, glowColor }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        filter: glowColor,
      }}
    >
      <path
        d="M14 1.75C7.23516 1.75 1.75 7.23516 1.75 14C1.75 20.7648 7.23516 26.25 14 26.25C20.7648 26.25 26.25 20.7648 26.25 14C26.25 7.23516 20.7648 1.75 14 1.75ZM14 24.1719C8.38359 24.1719 3.82812 19.6164 3.82812 14C3.82812 8.38359 8.38359 3.82812 14 3.82812C19.6164 3.82812 24.1719 8.38359 24.1719 14C24.1719 19.6164 19.6164 24.1719 14 24.1719ZM15.3043 13.3656L14.6098 13.2043V9.53203C15.6488 9.67422 16.2914 10.325 16.4008 11.1234C16.4145 11.2328 16.5074 11.3121 16.6168 11.3121H17.8445C17.973 11.3121 18.0742 11.2 18.0633 11.0715C17.8965 9.36797 16.4938 8.27422 14.6207 8.08555V7.19141C14.6207 7.07109 14.5223 6.97266 14.402 6.97266H13.6336C13.5133 6.97266 13.4148 7.07109 13.4148 7.19141V8.09375C11.4789 8.28242 9.96406 9.35156 9.96406 11.3477C9.96406 13.1961 11.3258 14.0875 12.7559 14.4293L13.4313 14.6016V18.5035C12.2227 18.3422 11.5445 17.6969 11.4051 16.8273C11.3887 16.7234 11.2957 16.6469 11.1891 16.6469H9.92578C9.79727 16.6469 9.69609 16.7563 9.70703 16.8848C9.83008 18.3887 10.9703 19.7723 13.4039 19.95V20.8086C13.4039 20.9289 13.5023 21.0273 13.6227 21.0273H14.3992C14.5195 21.0273 14.618 20.9289 14.618 20.8059L14.6125 19.9391C16.7535 19.7504 18.2848 18.6047 18.2848 16.5484C18.282 14.6508 17.0762 13.8031 15.3043 13.3656ZM13.4285 12.9227C13.2754 12.8789 13.1469 12.8379 13.0184 12.7859C12.0941 12.4523 11.6648 11.9137 11.6648 11.2191C11.6648 10.2266 12.4168 9.66055 13.4285 9.53203V12.9227ZM14.6098 18.5117V14.8559C14.6945 14.8805 14.7711 14.8996 14.8504 14.916C16.1437 15.3098 16.5785 15.8566 16.5785 16.6961C16.5785 17.7652 15.7746 18.4078 14.6098 18.5117Z"
        fill={color}
      />
    </svg>
  )
}

export default AprIcon
